import { getApp } from "firebase/app"
import { getFunctions } from "firebase/functions"

export function getConfiguredFunctions() {
   return getFunctions(getApp(), "europe-west9")
}
